/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

const useSyllabus = (
  goalUID,
  isNewSyllabus,
  extraParams,
  isRecordedGoal,
  options = {
    fallbackData: undefined
  }
) => {
  const key = `v1/syllabus/${
    isRecordedGoal ? 'recorded_content_home/recorded_feed' : 'home/feed'
  }/?goal_uid=${goalUID}${
    extraParams?.educator_uid ? `&educator_uid=${extraParams.educator_uid}` : ''
  }`;

  const {
    data: syllabusData,
    isValidating,
    ...rest
  } = useFetch(
    isNewSyllabus ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    syllabusData,
    isValidating,
    ...rest
  };
};

export default useSyllabus;
